import React from "react";

const Footer: React.FC = () => {
  return "";
};

export default Footer;
